import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CacheState } from './cache.reducer';

export const selectCacheState = createFeatureSelector<CacheState>('cache');

export const selectCachedData = (key: string) =>
  createSelector(selectCacheState, (state) => state?.[key]);

export const selectCacheKeys = createSelector(
  selectCacheState,
  (state) => Object.keys(state)
);

export const selectCacheSize = createSelector(
  selectCacheState,
  (state) => Object.keys(state).length
);
